/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Overage_Billing_NoteInputs */



/**
* | output |
* | --- |
* | "added to your next invoice" |
*
* @param {Usage_Tab_Overage_Billing_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_overage_billing_note = /** @type {((inputs?: Usage_Tab_Overage_Billing_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Overage_Billing_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("wird Ihrer nächsten Rechnung hinzugefügt")
	return /** @type {LocalizedString} */ ("added to your next invoice")
});